import { SettingsContent } from '/@/renderer/features/settings/components/settings-content';

export const SettingsContextModal = () => <SettingsContent />;
